import styled from 'styled-components';
import media from '../../constants/media';

export const Wrapper1 = styled.div`
	position: absolute;
	right: 5rem;
	top: 50rem;
	bottom: 0;
`;

export const Wrapper = styled.div`
	position: fixed;
	bottom: 1rem;
	right: 1rem;

	${media.desktopSmall`
		bottom: 7rem;
		right: 10rem;
	`}
`;

export const PopUp = styled.div`
	position: relative;
`;

export const Spacer = styled.div`
	z-index: -1;
	background: transparent;
	height: 10rem;
`;

export const BubbleWrapper = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border-radius: 100%;

	width: 10rem;
	height: 10rem;
	svg {
		width: 100%;
		height: 100%;
	}

	${media.desktopLarge`
		width: 10rem;
		height: 10rem;
	`}
`;
